/* This class handles the functionality request between the pages of the application*/
import {Injectable} from '@angular/core';
import { SidebarComponent } from './../components/sidebar/sidebar.component';

/* Subclassess that subdivides the functionalityes per page */
export class Home_functions {
    // flags
    FLAG_getDetails             = false;
    FLAG_getDeliveries          = false;
    FLAG_getMaterial            = false;

    FLAG_statefulOda            = false;
    FLAG_statefulLot            = false;
    // values
    getDetails_order_number     = undefined;
    getDeliveries_order_number  = undefined;
    getMaterial_material_code   = undefined;

    getState_order_number       = '';
    getState_lot_number       = '';
    // |Reset the entire value system
    clear() {
        // clear all the flags
        this.FLAG_getDetails    = false;
        this.FLAG_getDeliveries = false;
        this.FLAG_getMaterial   = false;
        // clear all the data
        this.getDetails_order_number    = undefined;
        this.getDeliveries_order_number = undefined;
        this.getMaterial_material_code       = undefined;
    }

}
export class Lot_functions {
    // flags
    FLAG_getMaterial          = false;
    // values
    getMaterial_supplier_code  = undefined;
    getMaterial_material_code = undefined;
    // |Reset the entire value system
    clear() {
        // clear all the flags
        this.FLAG_getMaterial = false;
        // clear all the data
        this.getMaterial_supplier_code = undefined;
        this.getMaterial_material_code = undefined;
    }
}
export class Order_functions {
    // flags
    FLAG_getDeliveries          = false;
    FLAG_copyFromOrders         = false;
    // values
    getDeliveries_order_number  = undefined;
    copyFromOrdersMaterial      = undefined;
    // |Reset the entire value system
    clear() {
        // clear all the flags
        this.FLAG_getDeliveries = false;
        this.FLAG_copyFromOrders = false;
        // clear all the data
        this.getDeliveries_order_number = undefined;
        this.copyFromOrdersMaterial = undefined;
    }
}

export class Delivery_function {
  FLAG_autosearch             = false;
  autosearch_code             = undefined;

  clear() {
      // clear the flags
      this.FLAG_autosearch    = false;
      this.autosearch_code    = undefined;
  }
}

export class CAT_functions {
    // flags
    FLAG_autosearch             = false;
    FLAG_order                 = false;

    autosearch_code             = undefined;
    order_code                  = undefined;
    clear() {
        // clear the flags
        this.FLAG_autosearch    = false;
        this.FLAG_order        = false;
        this.autosearch_code    = undefined;
        this.order_code         = undefined;
    }
}

export class Invoice_functions {
    // flags
    FLAG_autosearch             = false;
    autosearch_code             = undefined;
    autosearch_order_code       = undefined;

    clear() {
        // clear the flags
        this.FLAG_autosearch    = false;
        this.autosearch_order_code = undefined;
        this.autosearch_code    = undefined;
    }
}
// |class exportation
@Injectable()
export class InternalFunctionsRedirectService {

    private sidebar: SidebarComponent;
    private home: Home_functions = new Home_functions();
    private lot: Lot_functions = new Lot_functions();
    private order: Order_functions = new Order_functions();
    private cat: CAT_functions = new CAT_functions();
    private delivery: Delivery_function = new Delivery_function();
    private invoice: Invoice_functions = new Invoice_functions();
    private backZone = '';

    constructor () {

    }

    setSidebar(value: SidebarComponent) {
        this.sidebar = value;
    }

    setBackZone(value) {
        this.backZone = value;
    }
    
    comeBack() { this.getSidebar().setMenuItem(this.backZone); this.backZone = '';}
    
    getSidebar() {
        return this.sidebar;
    }

    clearAllFunctionsData() {
        this.home.clear();
        this.lot.clear();
        this.order.clear();
        this.cat.clear();
        this.delivery.clear();
        this.invoice.clear();
    }

    getHomeFunctions() {
        return this.home;
    }

    getLotFunctions() {
        return this.lot;
    }

    getOrderFunctions() {
        return this.order;
    }

    getCatFunctons() {
        return this.cat;
    }

    getInvoiceFunctions() {
      return this.invoice;
    }

    getDeliveryFunctions() {
        return this.delivery;
    }
}



// WEBPACK FOOTER //
// ./src/app/service/internalFunctionsRedirectService.service.ts